module.exports = __webpack_public_path__ + "img/help-him.eca1f327.png";